<template>
  <div class="stepbar-wrap">
    <div class="stepbar-row">
      <ol class="stepbar">
        <li :class="{'done':step1Done}">
          <span></span>
          <br>
          1. プラン選択
        </li>
        <li :class="{'done':step2Done}">
          <span></span>
          <br>
          2. 申込情報入力
        </li>
        <li>
          <span></span>
          <br>
          3. 決済情報登録
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'step'
    ],

    data () {
      return {
        step1Done: this.step >= 1,
        step2Done: this.step >= 2,
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../sass/variables';
  .stepbar-wrap {display: grid;width: 100%;}
  .stepbar-row {margin: auto;}
  .stepbar {display: flex;position: relative;padding: 0;text-align: center;}
  .stepbar li {font-size: 12px;list-style: none;padding-left: 68px;position: relative;}
  .stepbar li:after {background-color: #c7dafc;content: "";height: 1px;position: absolute;top: 16px;left: -30px;width: 130px;z-index: inherit;}
  .stepbar li:first-child {padding-left: 0;}
  .stepbar li:first-child:after {display: none;}
  .stepbar li span {background-color: #c7dafc;border-radius: 50%;color: #fff;display: inline-block;height: 32px;margin-bottom: 4px;line-height: 32px;text-align: center;width: 32px;-moz-border-radius: 50%;-webkit-border-radius: 50%;}
  .stepbar .done:after {background-color: $cKey;}
  .stepbar .done {z-index: 10;}
  .stepbar .done span {background-color: $cKey;}
</style>
